import React, {useState} from 'react';
import {Copy, Check, Link as LinkIcon} from 'lucide-react';

export const EntryLinks=({slug,compact=false})=>{
  const [copied,setCopied]=useState(''),[error,setError]=useState('');
  const links=[['entry','Entrée',`/${slug}/login`],['demo-direction','Démo direction',`/${slug}/demo?view=direction`],['demo-salarie','Démo salarié',`/${slug}/demo?view=salarie`],['admin','Direction',`/${slug}/login?mode=admin`],['employee','Salarié',`/${slug}/login?mode=salarie`]];
  const copy=async(key,path)=>{
    try{await navigator.clipboard.writeText(`${window.location.origin}${path}`);setCopied(key);setError('');}
    catch{setError('Copie le lien depuis son adresse.');}
  };
  return <details className={`entry-share ${compact?'entry-share-compact':''}`} data-testid="entry-share">
    <summary data-testid="entry-share-toggle"><LinkIcon size={15}/> Liens de présentation</summary>
    <div className="entry-share-list">{links.map(([key,label,path])=><div key={key} className="entry-share-row">
      <a href={path} data-testid={`entry-link-${key}`}>{label}</a>
      <button type="button" onClick={()=>copy(key,path)} title={`Copier le lien ${label}`} aria-label={`Copier le lien ${label}`} data-testid={`entry-copy-${key}`}>
        {copied===key?<Check size={16}/>:<Copy size={16}/>}
      </button>
    </div>)}</div>
    {error&&<p role="alert" data-testid="entry-copy-error">{error}</p>}
  </details>;
};